import * as React from 'react';
import * as styled from './styled';
import {TaskProgressType} from 'api/task/types';
import {ResultGroupProps} from './types';

/**
 * The group of task results.
 * @param {ResultGroupProps} props
 * @return {React.ReactElement<ResultGroupProps>}
 * @constructor
 */
export default function ResultGroup(
    props: ResultGroupProps,
): React.ReactElement<ResultGroupProps> {
  /**
   * Render total.
   * @return {JSX.Element}
   */
  function renderTotal(): JSX.Element {
    return (
      <styled.Total>
        Результат: задание еще не проверено
      </styled.Total>
    );
  }

  /**
   * Render result.
   * @return {JSX.Element | undefined}
   */
  function renderResult(): JSX.Element | undefined {
    switch (props.progress?.status) {
      case TaskProgressType.Success: return (
        <styled.Result type={props.progress?.status}>
          Сдано!
        </styled.Result>
      );
      case TaskProgressType.Fail: return (
        <styled.Result type={props.progress?.status}>
          Не сдано!
        </styled.Result>
      );
    }
  }

  /**
   * Render list.
   * @return {JSX.Element}
   */
  function renderList(): JSX.Element {
    /**
     * Render min points label.
     * @return {JSX.Element}
     */
    function renderMinPoints(): JSX.Element {
      /**
       * Get min point.
       * @return {number}
       */
      function getMin(): number {
        return props.settings.estimate.points[0];
      }

      return (
        <styled.Item>
          Минимальное количество баллов для общего зачета:
          <span>{getMin()}</span>
        </styled.Item>
      );
    }

    /**
     * Render max points label.
     * @return {JSX.Element}
     */
    function renderMaxPoints(): JSX.Element {
      /**
       * Get max point.
       * @return {number}
       */
      function getMax(): number {
        return props.settings.estimate.points[
          props.settings.estimate.points.length - 1
        ];
      }

      return (
        <styled.Item>
          Максимально возможный балл:
          <span>{getMax()}</span>
        </styled.Item>
      );
    }

    return (
      <styled.List>
        {renderMinPoints()}
        {renderMaxPoints()}
        <styled.Item>
          Баллы учитываются в общем рейтинге
        </styled.Item>
      </styled.List>
    );
  }

  return (
    <styled.Wrapper>
      {renderTotal()}
      {renderResult()}
      {renderList()}
    </styled.Wrapper>
  );
}
